module.exports = __webpack_public_path__ + "img/3.08.thmb.4679d14a.jpg";